import { Format } from "../api/utils";
import dayjs from "dayjs";

export function _dateFormat(date, fmt) {
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`);
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return fmt;
}

export function getNearestWeekDates(val) {
  const endDate = Format("yyyy-MM-dd", new Date());
  const nowDate = new Date();
  nowDate.setDate(nowDate.getDate() - (val || 7));
  const y = nowDate.getFullYear();
  const m =
    nowDate.getMonth() + 1 > 9
      ? nowDate.getMonth() + 1
      : `0${nowDate.getMonth() + 1}`;
  const d = nowDate.getDate() > 9 ? nowDate.getDate() : `0${nowDate.getDate()}`;
  const startDate = `${y}-${m}-${d}`;
  return [startDate, endDate];
}

export function getInTheLatestWeek(val) {
  const startDate = dayjs()
    .startOf("day")
    .subtract(val || 7, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const endDate = dayjs()
    .endOf("day")
    .format("YYYY-MM-DD HH:mm:ss");
  return [startDate, endDate];
}

export function countDateDistance(dateEnd, dateStart) {
  const dateDiff =
    (new Date(dateEnd) - new Date(dateStart)) / (24 * 3600 * 1000);
  return dateDiff;
}
export function dateBetween(dateEnd, dateStart, between = 120) {
  if (dateEnd && dateStart) {
    const dateDiff =
      (new Date(dateEnd) - new Date(dateStart)) / (24 * 3600 * 1000);
    return dateDiff < between;
  } else {
    return true;
  }
}
